import Online from './online'

import {createForm, createFromForm} from '../../../utils'

export function request(method, params, defaultParams = {}) {

    if (params instanceof FormData) {

        return Online[method]('/', createFromForm(params, defaultParams))

    } else if (params instanceof Object) {

        if (method === 'get' || method === 'delete') {

            return Online[method]('/', {
                params: {
                    ...defaultParams,
                    ...params
                }
            })
        }

        return Online[method]('/', createForm({
            ...defaultParams,
            ...params
        }))
    }
}